/**
 * @param {function} func
 * @param {function|undefined} [argGen]
 */
export const genericSWRFetcher = (func, argGen) => async (key) => {
  let args = [];
  if (argGen) {
    args = argGen(key);
  }

  const resp = await func(...args);
  if (resp.status === "ok") {
    return resp.data;
  }

  throw new Error(resp.message);
};

export const formatDateFromDatePicker = (dateObj) => {
  if (!dateObj) return null;
  return dateObj.format("YYYY-MM-DD");
};

/**
 * The one definition of a valid email address.
 *
 * MIRRORS `EMAIL_PATTERN`, `EMAIL_EDGE_JUNK` and `normalizeEmail` in
 * red-panda-api's lib/email.mjs, which is authoritative and explains the
 * pattern. Copied verbatim: `bin/check-email-mirrors.mjs` there fails if this
 * copy drifts. The API normalizes and checks every address it is sent, so a
 * check here only has to agree with it.
 */
export const EMAIL_PATTERN = String.raw`^(?=.{1,64}$)[A-Za-z0-9_+'\-]+(\.[A-Za-z0-9_+'\-]+)*@([A-Za-z0-9]([A-Za-z0-9\-]{0,61}[A-Za-z0-9])?\.)+[A-Za-z]{2,}$`;
export const EMAIL_RE = new RegExp(EMAIL_PATTERN);
const EMAIL_EDGE_JUNK = /^[\s\u200B-\u200D\u2060]+|[\s\u200B-\u200D\u2060]+$/g;

/** Strips the whitespace, visible or not, that copy-paste leaves around an address. */
export const normalizeEmail = (val) =>
  typeof val === "string" ? val.replace(EMAIL_EDGE_JUNK, "") : val;

/** react-hook-form `validate` for an email field: the API's rule, exactly. */
export const validateEmail = (val) =>
  EMAIL_RE.test(normalizeEmail(val ?? "")) || "Invalid email address";
